export function decodePlanId(planId) {
  if (!planId || typeof planId !== 'string') return null

  try {
    const base64 = planId.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const decoded = atob(padded)
    const slashIndex = decoded.indexOf('/')

    if (slashIndex <= 0 || slashIndex === decoded.length - 1) return null

    return {
      workspaceId: decoded.slice(0, slashIndex),
      jobId: decoded.slice(slashIndex + 1),
    }
  } catch {
    return null
  }
}
